<ion-header
  class="ion-no-border"
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-download-list-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      *ngIf="platformType !== platformEnum.desktop"
      class="bold"
      data-cy="download-list-label"
    >
      <span *ngIf="isDownload">
        {{ 'i18n.common.download' | translate }} {{ listName }}
      </span>
      <span *ngIf="!isDownload">
        {{ 'i18n.common.print' | translate }} {{ listName }}
      </span>
      <span *ngIf="isRecentPurchase"> Products</span>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="download-list_content"
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  scroll-y="false"
>
  <div
    class="body-content"
    [class.is-touch]="platformType !== platformEnum.desktop"
    [class.is-mobile]="platformType === platformEnum.mobile"
  >
    <div *ngIf="platformType === platformEnum.desktop" class="title">
      <ion-label class="bold" data-cy="download-list-label" *ngIf="isDownload">
        {{ 'i18n.common.download' | translate }} {{ listName }}
        <span *ngIf="isRecentPurchase"> Products</span>
      </ion-label>
      <ion-label class="bold" data-cy="print-list-label" *ngIf="!isDownload">
        {{ 'i18n.common.print' | translate }} {{ listName }}
        <span *ngIf="isRecentPurchase"> Products</span>
      </ion-label>
    </div>

    <div class="instructions" *ngIf="isDownload">
      <span>Choose your file name and format. Press</span>
      <span class="bold"> download </span>
      <span>to begin the list generation.</span>
    </div>

    <div class="instructions" *ngIf="!isDownload">
      <span>Customize how you would like your list printed.</span>
    </div>

    <div class="file-name-format-section" *ngIf="isDownload">
      <div class="file-name-section">
        <div class="label">
          <span>File Name</span>
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
        </div>
        <ion-item>
          <ion-input
            id="file-name-input"
            data-cy="file-name-input"
            maxlength="60"
            [(ngModel)]="fileName"
            data-cy="new-file-name-input"
          ></ion-input>
        </ion-item>
      </div>

      <div class="format-section">
        <div class="label">
          <span>Select Format</span>
          <span class="required-indicator">
            {{ 'i18n.common.requiredInputIndicator' | translate }}
          </span>
        </div>
        <ion-item
          class="format-button"
          data-cy="select-format-option"
          button
          detail="true"
          detail-icon="chevron-down-outline"
          (click)="openFiletypePopover($event)"
        >
          <span data-cy="select-format-option-value">
            {{ format }}
          </span>
        </ion-item>
      </div>
    </div>

    <div class="checkbox-buttons">
      <ion-item-divider></ion-item-divider>
      <ion-item class="price-checkbox" lines="none" *ngIf="!hidePricingOption">
        <ion-checkbox
          [(ngModel)]="includeProductPrices"
          mode="ios"
          justify="space-between"
          labelPlacement="start"
          >Product Prices</ion-checkbox
        >
      </ion-item>
      <ion-item-divider></ion-item-divider>
      <ion-item class="notes-checkbox" *ngIf="!isRecentPurchase">
        <ion-checkbox
          [(ngModel)]="includeProductNotes"
          mode="ios"
          justify="space-between"
          labelPlacement="start"
          >Product Notes</ion-checkbox
        >
      </ion-item>
      <ion-item-divider></ion-item-divider>
      <ion-item class="notes-checkbox">
        <ion-checkbox
          [(ngModel)]="includeProductStatusAndType"
          mode="ios"
          justify="space-between"
          labelPlacement="start"
          >Product Status and Type</ion-checkbox
        >
      </ion-item>
      <ion-item-divider></ion-item-divider>
      <ion-item class="notes-checkbox">
        <ion-checkbox
          [(ngModel)]="includeMasterListAssociation"
          mode="ios"
          justify="space-between"
          labelPlacement="start"
          >Master List Association</ion-checkbox
        >
      </ion-item>
      <ion-item-divider></ion-item-divider>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platformType !== platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-download-list-modal-button"
        [ngClass]="
          platformType !== platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="download-list-modal-button"
        [disabled]="!fileName"
        [ngClass]="
          platformType !== platformEnum.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="download()"
      >
        {{
          (isDownload ? 'i18n.common.download' : 'i18n.common.print')
            | translate
        }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
